import {
  ContainerEditActionTypes,
  ContainerEditActions,
  MoveActionSources,
  MoveItem,
  MoveItemAction,
  MoveSection,
  MoveSectionAction,
} from '../../state/container-edit.actions';
import {
  ContainerPersistEditActionTypes,
  PersistAction,
  PersistErrorAction,
  PersistPublishListAction,
  PersistResumePublishListAction,
} from '../../state/container-persist-edit.actions';

import { QueueActionTypes, QueueActions } from './queue.actions';
import { QueueState } from './queue.state';

function addPersistActionToQueue(
  state: QueueState,
  action: ContainerEditActions,
) {
  const queuedAction = new PersistAction(action);
  return {
    ...state,
    queue: state.queue.push(queuedAction),
  };
}

export type QueueReducerAction =
  | QueueActions
  | ContainerEditActions
  | PersistErrorAction;

export function queueReducer(
  state: QueueState,
  action: QueueReducerAction,
): QueueState {
  switch (action.type) {
    case QueueActionTypes.INIT_QUEUE: {
      const { etag } = action.payload;
      return { ...state, etag };
    }
    case QueueActionTypes.LOCK_QUEUE_FOR_SHIFT: {
      return { ...state, locked: true };
    }
    case QueueActionTypes.UNLOCK_QUEUE_AND_SHIFT: {
      const { persistAction, etag } = action.payload;
      if (persistAction !== state.queue.first()) {
        return state;
      }
      return {
        ...state,
        queue: state.queue.shift(),
        locked: false,
        etag,
      };
    }
    case QueueActionTypes.UPDATE_QUEUE_ETAG: {
      const { etag } = action.payload;
      return state.locked ? state : { ...state, etag };
    }

    case ContainerEditActionTypes.CONFIRM_CREATE_NOTE_ITEM:
    case ContainerEditActionTypes.CONFIRM_UPDATE_NOTE_ITEM:
    case ContainerEditActionTypes.CONFIRM_CREATE_RESOURCE_ITEM:
    case ContainerEditActionTypes.UPDATE_RESOURCE_ITEM_IMPORTANCE:
    case ContainerEditActionTypes.DELETE_RESOURCE_ITEM_IMPORTANCE:
    case ContainerEditActionTypes.DELETE_RESOURCE_ITEM_STUDENT_NOTE:
    case ContainerEditActionTypes.DELETE_RESOURCE_ITEM_LIBRARY_NOTE:
    case ContainerEditActionTypes.CONFIRM_UPDATE_RESOURCE_ITEM_STUDENT_NOTE:
    case ContainerEditActionTypes.CONFIRM_UPDATE_RESOURCE_ITEM_LIBRARY_NOTE:
    case ContainerEditActionTypes.CONFIRM_CREATE_SECTION:
    case ContainerEditActionTypes.CONFIRM_UPDATE_SECTION:
    case ContainerEditActionTypes.MOVE_ITEM:
    case ContainerEditActionTypes.CONFIRM_DELETE_ITEM:
    case ContainerEditActionTypes.CONFIRM_DELETE_SECTION:
    case ContainerEditActionTypes.MOVE_SECTION: {
      return addPersistActionToQueue(state, action);
    }

    case ContainerEditActionTypes.PUBLISH_LIST: {
      return {
        ...state,
        queue: state.queue.push(new PersistPublishListAction(action)),
      };
    }
    case ContainerEditActionTypes.RESUME_PUBLISH_LIST: {
      return {
        ...state,
        queue: state.queue.push(new PersistResumePublishListAction(action)),
      };
    }

    case ContainerEditActionTypes.PASTE_ITEM: {
      const { listId, item, from, to } = action.payload;
      const source = MoveActionSources.PASTE;
      const payload: MoveItem = { listId, item, from, to, source };
      const moveItemAction = new MoveItemAction(payload);

      return addPersistActionToQueue(state, moveItemAction);
    }
    case ContainerEditActionTypes.PASTE_SECTION: {
      const { listId, section, from, to } = action.payload;
      const source = MoveActionSources.PASTE;
      const payload: MoveSection = { listId, section, from, to, source };
      const moveSectionAction = new MoveSectionAction(payload);

      return addPersistActionToQueue(state, moveSectionAction);
    }

    case ContainerPersistEditActionTypes.PERSIST_ERROR: {
      return {
        ...state,
        error: action.payload.error,
      };
    }

    default: {
      return state;
    }
  }
}
